export const missionData = {
  Mercury: [
    {
      name: "Mariner 10",
      year: 1973,
      status: "Success",
      description: "First spacecraft to visit Mercury via flybys.",
      importance: "Revealed Mercury’s magnetic field and surface.",
      speed: "69,800 km/h",
      distance: "~77 million km",
      cost: "$100M USD",
      images: ["mariner10spacecraft", "mariner10"],
    },
    {
      name: "MESSENGER",
      year: 2004,
      status: "Success",
      description: "First to orbit Mercury, mapped terrain and composition.",
      importance: "Found water ice and volatile elements.",
      speed: "58,000 km/h",
      distance: "~77 million km",
      cost: "$446M USD",
      images: ["messengerspacecraft", "messenger"],
    },
    {
      name: "BepiColombo",
      year: 2018,
      status: "Ongoing",
      description: "Ongoing ESA‑JAXA mission to orbit Mercury.",
      importance: "Will study surface and magnetic field in detail.",
      speed: "~56,000 km/h",
      distance: "~77 million km",
      cost: "~$2B USD",
      images: ["bepicolombospacecraft", "bepicolombo"],
    },
  ],

  Venus: [
    {
      name: "Mariner 2",
      year: 1962,
      status: "Success",
      description: "First successful flyby of Venus; focused on atmospheric measurements.",
      importance: "Confirmed Venus’s extremely high surface temperature.",
      speed: "54,000 km/h",
      distance: "~41 million km",
      cost: "$47M USD",
      images: ["mariner2spacecraft"],
    },
    {
      name: "Venera 7",
      year: 1970,
      status: "Partial Success",
      description: "First probe to transmit data from Venus’s surface; measured temperature and pressure.",
      importance: "Demonstrated Venus’s extreme surface conditions.",
      speed: "~39,600 km/h",
      distance: "~41 million km",
      cost: "USSR mission – estimated ~$200M USD",
      images: ["venera7spacecraft"],
    },
    {
      name: "Venera 13",
      year: 1982,
      status: "Success",
      description: "Returned the first color images from Venus’s surface.",
      importance: "Provided critical geochemical and visual data.",
      speed: "~40,200 km/h",
      distance: "~41 million km",
      cost: "USSR mission – estimated ~$250M USD",
      images: ["venera13spacecraft", "venera13"],
    },
    {
      name: "Pioneer Venus",
      year: 1978,
      status: "Success",
      description: "Orbiter and multiprobe mission studying Venus’s atmosphere and surface via radar mapping.",
      importance: "Advanced understanding of upper atmosphere and surface structures.",
      speed: "41,500 km/h",
      distance: "~41 million km",
      cost: "$125M USD",
      images: ["pioneervenusspacecraft", "pioneervenus"],
    },
    {
      name: "Magellan",
      year: 1989,
      status: "Success",
      description: "Mapped ~98% of Venus’s surface using radar.",
      importance: "Revealed volcanic, mountainous, and tectonic features.",
      speed: "45,000 km/h",
      distance: "~41 million km",
      cost: "$680M USD",
      images: ["magellanspacecraft", "magellan"],
    },
    {
      name: "Venus Express",
      year: 2005,
      status: "Success",
      description: "ESA orbiter studying Venus’s atmosphere and climate.",
      importance: "Discovered atmospheric super‑rotation and surface variability.",
      speed: "42,000 km/h",
      distance: "~41 million km",
      cost: "€220M EUR (~$265M USD)",
      images: ["venusexpressspacecraft", "venusexpress"],
    },
    {
      name: "Akatsuki",
      year: 2010,
      status: "Success",
      description: "Japan’s climate orbiter examining cloud motion and surface temperature.",
      importance: "Provided detailed Venusian weather patterns.",
      speed: "40,000 km/h",
      distance: "~41 million km",
      cost: "$300M USD",
      images: ["akatsukispacecraft", "akatsuki"],
    },
    {
      name: "DAVINCI+",
      year: "TBD",
      status: "Planned",
      description: "NASA mission to study Venus’s atmosphere during descent.",
      importance: "Will deliver high‑resolution atmospheric profiles.",
      speed: "TBD",
      distance: "TBD",
      cost: "TBD",
      images: [],
    },
    {
      name: "VERITAS",
      year: "TBD",
      status: "Planned",
      description: "NASA radar mapping orbiter.",
      importance: "Will investigate surface geology and tectonic activity.",
      speed: "TBD",
      distance: "TBD",
      cost: "TBD",
      images: [],
    },
    {
      name: "EnVision",
      year: "2030s",
      status: "Planned",
      description: "ESA mission to study Venus’s geology and atmosphere via high‑res radar and spectrometry.",
      importance: "Will complement NASA efforts with detailed geologic data.",
      speed: "TBD",
      distance: "TBD",
      cost: "TBD",
      images: [],
    },
  ],
  Mars: [
    {
      name: "Mariner 4",
      year: 1964,
      status: "Success",
      description: "First successful Mars flyby, providing close‑up images.",
      importance: "Delivered first up‑close images of another planet.",
      speed: "56,000 km/h",
      distance: "~78 million km",
      cost: "$83M USD",
      images: ["mariner4spacecraft", "mariner4"],
    },
    {
      name: "Viking 1 & 2",
      year: 1975,
      status: "Success",
      description: "First U.S. landers that conducted life‑detection experiments.",
      importance: "Searched for biosignatures on Mars’s surface.",
      speed: "54,600 km/h | Land speed: ~0.03 km/h",
      distance: "~78 million km",
      cost: "$1B USD combined",
      images: ["vikingspacecraft", "viking"],
    },
    {
      name: "Mars Pathfinder / Sojourner",
      year: 1996,
      status: "Success",
      description: "First rover mission on Mars.",
      importance: "Demonstrated rover mobility on Mars.",
      speed: "50,700 km/h | Land speed: ~0.05 km/h",
      distance: "~78 million km",
      cost: "$280M USD",
      images: ["sojournerspacecraft", "sojourner"],
    },
    {
      name: "Mars Express",
      year: 2003,
      status: "Success",
      description: "ESA orbiter for water and atmospheric studies.",
      importance: "Mapped water and analyzed atmospheric composition.",
      speed: "58,000 km/h",
      distance: "~78 million km",
      cost: "€300M EUR (~$360M USD)",
      images: ["marsexpressspacecraft", "marsexpress"],
    },
    {
      name: "Spirit & Opportunity",
      year: 2003,
      status: "Success",
      description: "Twin rovers that found strong signs of past water.",
      importance: "Provided evidence for historical fluvial activity.",
      speed: "58,000 km/h | Land speed: ~0.18 km/h",
      distance: "~78 million km",
      cost: "$820M USD combined",
      images: ["spiritspacecraft", "spirit"], // reuse or dedicated keys
    },
    {
      name: "MAVEN",
      year: 2013,
      status: "Success",
      description: "Orbiter exploring atmospheric loss processes.",
      importance: "Studied the escape of Mars’s atmosphere to space.",
      speed: "48,000 km/h",
      distance: "~78 million km",
      cost: "$671M USD",
      images: ["mavenspacecraft", "maven"],
    },
    {
      name: "Curiosity",
      year: 2011,
      status: "Success",
      description: "Nuc‑powered rover searching for habitable environments.",
      importance: "Detected past habitable conditions in Gale Crater.",
      speed: "56,000 km/h | Land speed: ~0.14 km/h",
      distance: "~78 million km",
      cost: "~$3.2B USD lifecycle cost (2020)", 
      images: ["curiosityspacecraft", "curiosity"],
    },
    {
      name: "InSight",
      year: 2018,
      status: "Success",
      description: "Lander studying Mars’s interior with seismometry.",
      importance: "Deployed the first Martian seismometer.",
      speed: "47,000 km/h",
      distance: "~78 million km",
      cost: "~$830M USD total", 
      images: ["insightspacecraft", "insight"],
    },
    {
      name: "Perseverance",
      year: 2020,
      status: "Success",
      description: "Rover collecting samples with an aerial scout (Ingenuity).",
      importance: "Searching for biosignatures with sample caching capability.",
      speed: "56,000 km/h | Land speed: ~0.16 km/h",
      distance: "~78 million km",
      cost: "$2.7B USD",
      images: ["perseverancespacecraft", "perseverance"],
    },
    {
      name: "Tianwen‑1 / Zhurong",
      year: 2021,
      status: "Success",
      description: "China’s first orbiter‑rover combo on Mars.",
      importance: "Marked China’s entry into Mars surface exploration.",
      speed: "~55,000 km/h | Land speed: ~0.14 km/h",
      distance: "~78 million km",
      cost: "~$700M USD (estimate)",
      images: ["zhurongspacecraft", "zhurong"],
    },
  ],

  Jupiter: [
    {
      name: "Pioneer 10",
      year: 1972,
      status: "Success",
      description: "First spacecraft to fly by Jupiter.",
      importance: "Provided groundbreaking close‑up observations.",
      speed: "132,000 km/h",
      distance: "~588 million km",
      cost: "$150M USD",
      images: ["pioneer10spacecraft", "pioneer10"],
    },
    {
      name: "Voyager 1 & 2",
      year: 1977,
      status: "Success",
      description: "“Grand Tour” flybys of outer planets including Jupiter.",
      importance: "Unveiled details of moons, rings, and magnetosphere.",
      speed: "160,000 km/h",
      distance: "~588 million km",
      cost: "$865M USD combined",
      images: ["voyager1spacecraft", "voyager1_jupiter"],
    },
    {
      name: "Galileo",
      year: 1989,
      status: "Success",
      description: "First orbiter around Jupiter with probe deployment.",
      importance: "Analyzed atmosphere and major moons thoroughly.",
      speed: "110,000 km/h",
      distance: "~588 million km",
      cost: "Estimated $634M USD initial; total higher", 
      images: ["galileospacecraft", "galileo"],
    },
    {
      name: "Juno",
      year: 2011,
      status: "Success",
      description: "Polar orbiter studying Jupiter’s core structure and auroras.",
      importance: "Delivered deep gravity and magnetic maps.",
      speed: "TBD (periapsis high-speed passes)",
      distance: "~588 million km",
      cost: "~$1.46B USD through 2022",
      images: ["junospacecraft", "juno"],
    },
    {
      name: "JUICE",
      year: 2023,
      status: "Ongoing",
      description: "ESA mission to study icy moons like Ganymede.",
      importance: "Aims to assess habitability in Jupiter system.",
      speed: "TBD",
      distance: "~588 million km",
      cost: "€1.5B (~$1.6B USD)",
      images: ["juiceSpacecraft"],
    },
  ],

  Saturn: [
    {
      name: "Pioneer 11",
      year: 1973,
      status: "Success",
      description: "First spacecraft to fly by Saturn.",
      importance: "Discovered rings and new satellites.",
      speed: "120,000 km/h",
      distance: "~1.2 billion km",
      cost: "$150M USD",
      images: ["pioneer11spacecraft", "pioneer11"],
    },
    {
      name: "Voyager 1 & 2",
      year: 1977,
      status: "Success",
      description: "Follow‑up flybys giving extensive atmospheric & ring data.",
      importance: "Revealed Saturn’s complex ring structure and atmosphere.",
      speed: "160,000 km/h",
      distance: "~1.2 billion km",
      cost: "$865M USD combined",
      images: ["voyager1_saturn"],
    },
    {
      name: "Cassini–Huygens",
      year: 1997,
      status: "Success",
      description: "Orbiter and Titan lander mission uncovering Enceladus plumes and Titan’s surface.",
      importance: "Transformed our understanding of the Saturnian system.",
      speed: "108,000 km/h",
      distance: "~1.2 billion km",
      cost: "$3.9B USD total",
      images: ["cassinihuygensspacecraft", "cassinihuygens"],
    },
  ],

  Uranus: [
    {
      name: "Voyager 2",
      year: 1986,
      status: "Success",
      description: "Only spacecraft to visit Uranus.",
      importance: "Mapped rings, moons, and revealed a tilted magnetic field.",
      speed: "160,000 km/h",
      distance: "~2.6 billion km",
      cost: "$865M USD (shared with Voyager 1)",
      images: ["voyager2spacecraft", "voyager2_uranus"],
    },
  ],

  Neptune: [
    {
      name: "Voyager 2",
      year: 1989,
      status: "Success",
      description: "Only spacecraft to visit Neptune.",
      importance: "Discovered the Great Dark Spot, rings, and Triton geyser detection.",
      speed: "160,000 km/h",
      distance: "~4.3 billion km",
      cost: "$865M USD (shared with Voyager 1)",
      images: ["voyager2_neptune"],
    },
  ],
  Moon: [
    {
      name: "Luna 2",
      year: 1959,
      status: "Success",
      description: "First spacecraft to reach the Moon via a controlled impact.",
      importance: "Marked humanity's first successful mission to another celestial body.",
      speed: "~39,000 km/h",
      distance: "~384,400 km",
      cost: "Unknown (Soviet program)",
      images: ["luna2spacecraft", "luna2"],
    },
    {
      name: "Surveyor 1",
      year: 1966,
      status: "Success",
      description: "First successful U.S. soft landing on the Moon.",
      importance: "Demonstrated soft-landing technology for future Apollo missions.",
      speed: "~39,000 km/h | Landing speed: ~10 km/h",
      distance: "~384,400 km",
      cost: "$469M USD (Surveyor program)",
      images: ["surveyorspacecraft", "surveyor"],
    },
    {
      name: "Apollo 11",
      year: 1969,
      status: "Success",
      description: "First crewed mission to land astronauts on the Moon.",
      importance: "Achieved the first human landing on another world.",
      speed: "~39,900 km/h | Landing speed: ~6 km/h",
      distance: "~384,400 km",
      cost: "~$355M USD mission (~$25.8B Apollo program)",
      images: ["apollo11spacecraft", "apollo11"],
    },
    {
      name: "Lunokhod 1",
      year: 1970,
      status: "Success",
      description: "First remotely operated rover on another celestial body.",
      importance: "Pioneered robotic surface exploration of the Moon.",
      speed: "~39,000 km/h | Rover speed: ~2 km/h",
      distance: "~384,400 km",
      cost: "Unknown (Soviet program)",
      images: ["lunokhod1spacecraft", "lunokhod1"],
    },
    {
      name: "Clementine",
      year: 1994,
      status: "Success",
      description: "Orbiter that globally mapped the lunar surface.",
      importance: "Provided evidence suggesting water ice near the lunar poles.",
      speed: "~38,000 km/h",
      distance: "~384,400 km",
      cost: "$80M USD",
      images: ["clementinespacecraft", "clementine"],
    },
    {
      name: "Lunar Reconnaissance Orbiter",
      year: 2009,
      status: "Success",
      description: "NASA orbiter conducting detailed mapping of the Moon.",
      importance: "Created the highest-resolution maps for future lunar missions.",
      speed: "~5,800 km/h (lunar orbit)",
      distance: "~384,400 km",
      cost: "$583M USD",
      images: ["lrospacecraft", "lro"],
    },
    {
      name: "Chang'e 4",
      year: 2018,
      status: "Success",
      description: "First spacecraft to land on the far side of the Moon.",
      importance: "Opened direct exploration of the Moon's far side.",
      speed: "~39,000 km/h | Rover speed: ~0.2 km/h",
      distance: "~384,400 km",
      cost: "Estimated $180M USD",
      images: ["change4spacecraft", "change4"],
    },
    {
      name: "Chang'e 5",
      year: 2020,
      status: "Success",
      description: "Robotic sample-return mission.",
      importance: "Returned the first lunar samples since 1976.",
      speed: "~39,000 km/h",
      distance: "~384,400 km",
      cost: "Estimated $250M USD",
      images: ["change5spacecraft", "change5"],
    },
    {
      name: "Artemis I",
      year: 2022,
      status: "Success",
      description: "Uncrewed Orion spacecraft test around the Moon.",
      importance: "Validated systems for returning astronauts to the Moon.",
      speed: "~39,500 km/h",
      distance: "~2.1 million km total mission",
      cost: "~$4.1B USD",
      images: ["artemis1spacecraft", "artemis1"],
    },
    {
      name: "Chandrayaan-3",
      year: 2023,
      status: "Success",
      description: "India's first successful lunar landing near the south pole.",
      importance: "First soft landing in the Moon's south polar region.",
      speed: "~39,000 km/h | Rover speed: ~0.1 km/h",
      distance: "~384,400 km",
      cost: "~$75M USD",
      images: ["chandrayaan3spacecraft", "chandrayaan3"],
    },
    {
      name: "Artemis II",
      year: 2026,
      status: "Success",
      description: "First crewed mission of NASA's Artemis program to fly around the Moon since Apollo 17.",
      importance: "Will test the Orion spacecraft and Space Launch System with astronauts aboard, paving the way for future lunar landings under Artemis III.",
      speed: "~39,500 km/h",
      distance: "~384,400 km",
      cost: "~$4.1B USD (mission estimate)",
      images: ["artemis2spacecraft", "artemis2"],
    },
  ],

  Pluto: [
    {
      name: "New Horizons",
      year: 2015,
      status: "Success",
      description: "First and only spacecraft to visit Pluto.",
      importance: "Captured the first close-up images of Pluto and Charon, discovered Sputnik Planitia, mapped Pluto's surface, studied its atmosphere, and explored the Kuiper Belt after the flyby.",
      speed: "58,500 km/h",
      distance: "~5.0 billion km",
      cost: "$720M USD",
      images: ["newhorizonsspacecraft", "newhorizons_pluto"],
    },
  ],
};

export const captionsMap ={
  // Mercury
  mariner10spacecraft: "Fig 1.0: Long, E. (2017). Mariner 10 [Photograph]. Smithsonian’s National Air and Space Museum.",
  mariner10: "Fig 1.1: NASA/JPL. (2001). Mercury’s Southern Hemisphere [Photomosaic image]. JPL Photojournal.",
  messengerspacecraft: "Fig 1.2: Johns Hopkins University Applied Physics Laboratory. (n.d.). MESSENGER. Johns Hopkins University Applied Physics Laboratory.",
  messenger: "Fig 1.3: NASA; Johns Hopkins University Applied Physics Laboratory; Carnegie Institution of Washington. (2008). Mercury in color (approximation of true‑color view) [Image]. NASA Science.",
  bepicolombospacecraft: "Fig 1.4: NASA. (2023). BepiColombo configuration [Image]. NASA Science.",
  bepicolombo: "Fig 1.5: European Space Agency. (2025). Top three images from BepiColombo's sixth Mercury flyby. European Space Agency.",

  // Venus
  mariner2spacecraft: "Fig 2.0: Eric Long. (n.d.). Mariner 2 spacecraft [Image]. Smithsonian’s National Air and Space Museum.",
  venera7spacecraft: "Fig 2.1: Zak, A. (n.d.). Venera-7 spacecraft on Venus surface (photograph) [Image]. RussianSpaceWeb.",
  venera13spacecraft: "Fig 2.2: The Space Collective. (2021). Venera spacecraft model [Image]. The Space Collective.",
  venera13: "Fig 2.3: Planetary Society. (n.d.). Venus surface panorama from Venera 13 front camera [Image]. The Planetary Society.",
  pioneervenusspacecraft: "Fig 2.4: NASA. (n.d.). Illustration of Pioneer Venus 1 spacecraft [Image]. NASA Science.",
  pioneervenus: "Fig 2.5: University of Colorado Boulder, Laboratory for Atmospheric and Space Physics. (n.d.). False-color ultraviolet image of Venus from Pioneer Venus Orbiter [Image].",
  magellanspacecraft: "Fig 2.6: NASA. (2023). Magellan spacecraft deployment from Space Shuttle [Image]. NASA Science.",
  magellan: "Fig 2.7: NASA. (n.d.). Radar view of Venus’s surface [Image]. NASA Science.",
  venusexpressspacecraft: "Fig 2.8: European Space Agency. (2023). Venus Express spacecraft in orbit [Image]. NASA Science.",
  venusexpress: "Fig 2.9: European Space Agency. (2019). Earth’s evil twin [Image]. ESA.",
  akatsukispacecraft: "Fig 2.10: JAXA. (2023). Akatsuki spacecraft in orbit around Venus [Image]. NASA Science.",
  akatsuki: "Fig 2.11: Murakami et al. (2018). Venus Climate Orbiter UVI calibrated image [Image]. NASA Planetary Data System.",

  // Mars
  mariner4spacecraft: "Fig 3.0: NASA. (1964). Mariner 4 spacecraft diagram [Diagram]. NASA.",
  mariner4: "Fig 3.1: NASA/JPL. (2000). Mariner 4 image of Mariner Crater (frame 11E) [Image]. JPL Photojournal.",
  vikingspacecraft: "Fig 3.2: NASA/JPL-Caltech/University of Arizona. (2007). Viking Lander model [Diagram]. NASA.",
  viking: "Fig 3.3: NASA/JPL. (1997). Sunset at the Viking Lander 1 site [Image]. NASA.",
  sojournerspacecraft: "Fig 3.4: National Air and Space Museum. (n.d.). Mars Pathfinder Sojourner rover full-scale model [Photograph]. Smithsonian’s National Air and Space Museum.",
  sojourner: "Fig 3.5: NASA/JPL. (1999). Close-up view of 'Chimp' rock ('right eye') [Image]. JPL Photojournal.",
  marsexpressspacecraft: "Fig 3.6: NASA/JPL/Corby Waste. (n.d.). MARSIS radar pulses (artist’s conception) [Image]. Wikimedia Commons.",
  marsexpress: "Fig 3.7: European Space Agency. (2006). Eastern Scarp of Olympus Mons [Image]. ESA Science & Technology.",
  spiritspacecraft: "Fig 3.8: NASA/JPL-Caltech. (n.d.). Illustration of NASA’s Spirit rover on Mars [Image]. NASA Science.",
  spirit: "Fig 3.9: NASA/JPL-Caltech/Cornell University. (2012). Spirit Mars Rover in 'McMurdo' panorama [Image]. NASA.",
  mavenspacecraft: "Fig 3.10: NASA/Goddard Space Flight Center. (2014). MAVEN artist’s concept [Image]. JPL Photojournal.",
  maven: "Fig 3.11: NASA / University of Colorado / LASP. (2024). MAVEN detects auroras during solar storm on Mars [Image]. JPL Photojournal.",
  curiosityspacecraft: "Fig 3.12: NASA/JPL-Caltech/MSSS. (2018). Curiosity's dusty selfie at Duluth drill site [Image]. NASA Science.",
  curiosity: "Fig 3.13: NASA/JPL-Caltech. (2025). Curiosity captures Mars landscape while talking to an orbiter [Image]. JPL Photojournal.",
  insightspacecraft: "Fig 3.14: NASA/JPL-Caltech. (n.d.). InSight lander solar panels open in clean room [Photograph]. NASA Science.",
  insight: "Fig 3.15: NASA/JPL-Caltech. (2018). InSight’s first image from Mars [Image]. JPL Photojournal.",
  perseverancespacecraft: "Fig 3.16: Live Science. (2021). NASA’s Perseverance rover generates breathable oxygen on Mars [Photograph]. Live Science.",
  perseverance: "Fig 3.17: NASA/JPL-Caltech/MSSS/ASU. (2021). Mastcam-Z’s first 360-degree panorama [Photograph]. NASA.",
  zhurongspacecraft: "Fig 3.18: China National Space Administration. (2021). Selfie of the Zhurong rover and the landing platform [Photograph]. CGTN.",
  zhurong: "Fig 3.19: China National Space Administration. (2021). Martian landscape image [Photograph]. CGTN.",
  hopespacecraft: "Fig 3.20: AETOSWire. (2020). Photo of the deployed EMM Hope spacecraft prior to shipment [Photograph]. EPICOS.",
  hope: "Fig 3.21: Mohammed bin Rashid Space Centre. (n.d.). Hope spacecraft firing its thrusters to enter orbit around Mars [Photograph]. eoPortal Satellite Missions Catalogue.",
  exomarsspacecraft: "Fig 3.22: European Space Agency. (2016). ExoMars first colour image of Phobos [Photograph]. European Space Agency.",
  exomars: "Fig 3.23: NASA. (2023). ExoMars rover concept art [Illustration]. NASA Science.",

  // Jupiter
  pioneer10spacecraft: "Fig 4.0: Smith, D. (1965). Historic Jet Engine Display [Photograph]. Smithsonian National Air and Space Museum.",
  pioneer10: "Fig 4.1: Stryk, T. (n.d.). Pioneer 10 departs Jupiter (and Io) [Photograph]. The Planetary Society.",
  voyager1spacecraft: "Fig 4.2: NASA/JPL-Caltech. (2024). Artist concept of Voyager 1 [Digital image]. Scientific American.",
  voyager1_jupiter: "Fig 4.3: NASA/JPL-Caltech. (1990). Pale Blue Dot [Photograph]. NASA.",
  galileospacecraft: "Fig 4.4: NASA/JPL-Caltech. (n.d.). Artist concept of Galileo spacecraft [Digital image]. NASA Jet Propulsion Laboratory.",
  galileo: "Fig 4.5: NASA/JPL-Caltech/SETI Institute. (1996). Europa's stunning surface [Digital image]. Houston Chronicle.",
  junospacecraft: "Fig 4.6: NASA / Jet Propulsion Laboratory. (n.d.). Artist rendering of the Juno spacecraft orbiting Jupiter [Digital image]. NASA Jet Propulsion Laboratory.",
  juno: "Fig 4.7: Eason, G. (2024). NASA’s Juno mission captures the colorful and chaotic clouds of Jupiter [Color-enhanced image]. NASA/JPL-Caltech/SwRI/MSSS.",
  juicespacecraft: "Fig 4.8: European Space Agency. (2022). Juice launch kit cover close-up [Illustration of the JUICE spacecraft]. Wikimedia Commons.",

  // Saturn
  pioneer11spacecraft: "Fig 5.0: NASA. (n.d.). An artist's concept of NASA's Pioneer 11 spacecraft [Digital image]. NASA Science.",
  pioneer11: "Fig 5.1: NASA/Ames Research Center. (1979). Saturn, its rings, and Titan [Image]. NASA Science.",
  voyager1_saturn: "Fig 5.2: NASA/JPL. (1980). Voyager 1 image: Saturn and its rings, four days after closest approach [Image]. NASA.",
  cassinihuygensspacecraft: "Fig 5.3: NASA/JPL-Caltech. (2017). Cassini versus Saturn [Illustration]. NASA Photojournal.",
  cassinihuygens: "Fig 5.4: NASA/JPL-Caltech/Space Science Institute. (2018). Translucent Arcs [Color image of Saturn’s rings]. Cassini–Huygens mission. NASA Photojournal.",

  // Uranus
  voyager2spacecraft: "Fig 6.0: NASA/JPL-Caltech. (n.d.). Voyager 2. NASA Science.",
  voyager2_uranus: "Fig 6.1: NASA/JPL-Caltech. (1986). Uranus as seen by NASA's Voyager 2 [Color image]. NASA Photojournal.",

  // Neptune
  voyager2_neptune: "Fig 7.0: NASA. (2019). 30 years ago: Voyager 2’s historic Neptune flyby. NASA.",

  // Moon
  luna2spacecraft: "Fig 8.0: NASA. (1959). Luna 2 spacecraft illustration [Diagram]. NASA.",
  luna2: "Fig 8.1: NASA. (1959). Luna 2 crash site [Image]. NASA.",
  surveyorspacecraft: "Fig 8.2: NASA/JPL. (1966). Surveyor spacecraft diagram [Diagram]. NASA.",
  surveyor: "Fig 8.3: NASA. (1966). Surveyor 1 on the lunar surface [Image]. NASA.",
  apollo11spacecraft: "Fig 8.4: NASA. (1969). Apollo 11 crew conduct checks in the command module [Photograph]. NASA.",
  apollo11: "Fig 8.5: NASA. (1969). Buzz Aldrin on the Moon during Apollo 11 [Photograph]. NASA.",
  lunokhod1spacecraft: "Fig 8.6: Lavochkin Association. (1970). Lunokhod 1 rover diagram [Diagram]. Lavochkin.",
  lunokhod1: "Fig 8.7: NASA. (1970). Lunokhod 1 on the lunar surface [Illustration]. NASA.",
  clementinespacecraft: "Fig 8.8: NASA. (1994). Clementine spacecraft [Diagram]. NASA.",
  clementine: "Fig 8.9: NASA. (1994). Clementine global mosaic of the Moon [Image]. NASA.",
  lrospacecraft: "Fig 8.10: NASA/Goddard Space Flight Center. (2009). Lunar Reconnaissance Orbiter artist's concept [Illustration]. NASA.",
  lro: "Fig 8.11: NASA. (2011). LRO shows the Moon's farside in high resolution [Image]. NASA.",
  change4spacecraft: "Fig 8.12: China National Space Administration. (2018). Chang'e 4 lander and rover [Diagram]. CNSA.",
  change4: "Fig 8.13: China National Space Administration. (2019). Chang'e-4 on the Moon. CNSA.",
  change5spacecraft: "Fig 8.14: China National Space Administration. (2020). Chang'e 5 spacecraft configuration [Diagram]. CNSA.",
  change5: "Fig 8.15: China National Space Administration. (2020). Chang'e 5 sample return capsule after landing [Photograph]. CNSA.",
  artemis1spacecraft: "Fig 8.16: NASA. (2022). Artemis I Orion spacecraft. NASA.",
  artemis1: "Fig 8.17: NASA. (2022). Orion spacecraft view of the Moon during Artemis I [Photograph]. NASA.",
  chandrayaan3spacecraft: "Fig 8.18: Indian Space Research Organisation. (2023). Chandrayaan-3 lander and rover configuration [Diagram]. ISRO.",
  chandrayaan3: "Fig 8.19: Indian Space Research Organisation. (2023). Pragyan rover near the lunar south pole [Photograph]. ISRO.",
  artemis2spacecraft: "Fig 8.20: NASA. (2026). Orion spacecraft for the Artemis II mission. NASA.",
  artemis2: "Fig 8.21: NASA. (2026). Artemis II mission trajectory around the Moon. NASA.",

  // Pluto
  newhorizonsspacecraft: "Fig 9.0: NASA. (2006). New Horizons spacecraft before its mission to Pluto. NASA.",
  newhorizons_pluto: "Fig 9.1: NASA. (2015). Color image of Pluto captured by New Horizons during its flyby [Photograph]. NASA Photojournal.",
};
export default missionData;
